export default "__VITE_ASSET__Cl77OEkr__"